import * as Types from '../../../generated/gqlTypes';

import { gql } from '@apollo/client';
export type SaleFragment = { id: string, pk: number, name: string, availableTo: any, availableFrom: any | null, type: string, value: any };

export const SaleFragmentDoc = gql`
    fragment Sale on SaleType {
  id
  pk
  name
  availableTo
  availableFrom
  type
  value
}
    `;